import React from 'react';

import { UnallocatedAppointment } from '~weekly-planner/lib/common';

import Icon, { faInfoCircle } from '~components/icon';
import UnallocatedCard from '~weekly-planner/components/card/UnallocatedCard';

import { SPOOFED_UNALLOCATED } from '~rore/lib/spoofData';

interface ComponentProps {
  isOpen: boolean;
}

const RoREUnallocatedList: React.FC<ComponentProps> = ({ isOpen }) => {
  if (!isOpen) return null;

  const renderAppointment = (appointment: UnallocatedAppointment, index: number) => (
    <div key={index} className="unallocated-row">
      <div className="unallocated-card-container">
        <UnallocatedCard appointment={appointment} />
      </div>
    </div>
  );

  if (SPOOFED_UNALLOCATED.length === 0) {
    return (
      <div className="sidebar-list">
        <p className="no-result">
          <Icon icon={faInfoCircle} />
          No unallocated appointments
        </p>
      </div>
    );
  }

  return (
    <div className="sidebar-list">
      <div className="card-container unallocated-appointments inner-content limited">
        {SPOOFED_UNALLOCATED.map(renderAppointment)}
      </div>
    </div>
  );
};

export default RoREUnallocatedList;
